import React, { useContext, useEffect, useState } from "react";
import { useApiClient } from "../../context/ApiClientContext";
import { Backdrop, Box, CircularProgress, createTheme, Pagination, ThemeProvider, useMediaQuery, useTheme } from "@mui/material";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import { DataContext } from "./index";
import api from "../../helper/baseApi";
import CustomToolbar from "../../utils/customToolbar";

export default function ScoreList({ currentPage, totalPage, pageSize, id, handleShowButton }) {
  const rows = useContext(DataContext);
  const { apiUrls: { mobileApiUrl } } = useApiClient();
  const [filteredDataList, setFilteredDataList] = React.useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      fetchData(id);
    }
  }, [currentPage, pageSize, id]);

  const fetchData = async (id) => {
    await fetchDataAndUpdateList(currentPage, id);
  };

  
const fetchDataAndUpdateList = async (page, modal) => {
  let actualId;

  // 🔹 Safely extract the ID from modal
  if (typeof modal === "object" && modal !== null) {
    actualId = modal.rewardId || modal.id || modal.value;
  } else {
    actualId = modal;
  }

  const employeeId = localStorage.getItem("employeeId");

  try {
    setLoading(true);

    // 🔹 Use baseApi (interceptor adds token + headers automatically)
    const response = await api.get(`${mobileApiUrl}reward/reward-details-portal?rewardId=${id}`, {
    });

    const participants = response.data.data.employees || [];

    const dataWithKeys = participants.map((item) => ({
      ...item,
      id: item.employeeId,
    }));

    setFilteredDataList(dataWithKeys);
  } catch (error) {
    if (error?.response?.status === 404) {
      setFilteredDataList([]);
      console.log("No participants found");
    } else {
      console.error("An error occurred:", error?.response?.statusText || error.message);
    }
  } finally {
    setLoading(false);
  }
};

  const columns = [
    {
      field: "ranking",
      headerName: "Ranking",
      width: 80,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "code",
      headerName: "Employee Code",
      width: 200,
      // flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "name",
      headerName: "Full Name",
      width: 200,
      // flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "qualifyingPoint",
      headerName: "Qualifying Point",
      width: 100,
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
  ];


  return (
    <div>
      <Box
        // m="3px 0 0 0"
        style={{ height: 420, width: "100%" }}
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
            display: "flex",
            justifyContent: "space-around",
            // backgroundColor: "background.main",
          },

          "& .MuiDataGrid-scrollbar": {
            display: "none",
          },
        }}
      >

        {/* <ThemeProvider theme={theme}> */}
        {/* <div style={{ height: 450, width: "100%" }}> */}

        <DataGrid
          columns={columns}
          rows={filteredDataList}
          showToolbar
          slots={{ toolbar: CustomToolbar }}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 25 },
            },
          }}
          slotProps={{
            loadingOverlay: {
              variant: "linear-progress",
              noRowsVariant: "skeleton",
            },
            disableToolbarButton: {
              csvOptions: "true",
              printOptions: "true"
            },
            toolbar: {
              title: "Score Listing",
              printOptions: { disableToolbarButton: true },
              csvOptions: { disableToolbarButton: true }
            },
          }}
          disableRowSelectionOnClick
          localeText={{ noRowsLabel: "No records found" }}
        />
        {/* </div> */}
        {/* </ThemeProvider> */}
      </Box>
    </div>
  );
}

